import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3z","key":"svg-0"}],["path",{"d":"M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13","key":"svg-1"}]]

const IconBrandNexo = createReactComponent('outline', 'brand-nexo', 'BrandNexo', __iconNode);

export default IconBrandNexo;